<template>
  <!-- 电脑菜单 -->
  <div class="el-menu-horizontal-warp">
    <el-menu
      :default-active="getRouteIndex"
      class="hj-gf-menu"
      mode="horizontal"
      text-color="rgba(51, 51, 51, 1)"
      active-text-color="rgb(45, 132, 255 )"
    >
      <el-menu-item
        v-for="menu in menuList"
        :class="menu.path"
        :index="'/' + menu.path"
        :key="menu.menuItem"
        @click.native="handleSelect(menu)"
      >
        <span>
          {{ menu.menuItem }}
          <img
            v-if="menu.menuItem === '解决方案' || menu.menuItem === '产品介绍'"
            src="./new.png"
            alt=""
            class="new-icon"
          />
        </span>
        <!-- 二级菜单 -->
        <div v-if="menu.children" class="sub-menu">
          <!-- 分类结构（解决方案） -->
          <div
            v-if="menu.children[0] && menu.children[0].category"
            class="solution-menu-list"
          >
            <div
              v-for="category in menu.children.slice(0, -2)"
              :key="category.category"
              class="solution-category"
            >
              <div class="category-title">{{ category.category }}</div>
              <div class="category-items">
                <div
                  v-for="item in category.items"
                  :key="item.name"
                  class="category-item"
                  @click="handleProductClick(item.path, $event)"
                >
                  <span class="category-item-text">
                    {{ item.name }}
                    <img
                      v-if="item.new"
                      src="./new.png"
                      alt=""
                      class="new-icon"
                    />
                  </span>
                </div>
              </div>
            </div>
            <div
              v-if="menu.children.length >= 1"
              class="solution-category-column"
            >
              <div
                v-for="category in menu.children.slice(-2)"
                :key="category.category"
                class="solution-category"
              >
                <div class="category-title">{{ category.category }}</div>
                <div class="category-items">
                  <div
                    v-for="item in category.items"
                    :key="item.name"
                    class="category-item"
                    @click="handleProductClick(item.path, $event)"
                  >
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 平铺结构（产品介绍） -->
          <div v-else class="product-menu-list">
            <div
              v-for="product in menu.children"
              :key="product.name"
              class="product-menu-item"
              @click="handleProductClick(product.path, $event)"
            >
              <wb-icon :icon="product.icon"></wb-icon>
              {{ product.name }}
            </div>
          </div>
        </div>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'navMenuHorizontal',
  data() {
    return {}
  },
  computed: {
    getRouteIndex() {
      let routeName = this.$route.path
      routeName = routeName.split('/')
      return '/' + routeName[1]
    },
    menuList() {
      return this.$store.state.menuList
    }
  },
  mounted() {
    this.addEventToMenu()
  },
  methods: {
    addEventToMenu() {
      // 为所有有子菜单的菜单项添加悬停事件
      this.$nextTick(() => {
        const menuItems = this.menuList.filter((menu) => menu.children)
        menuItems.forEach((menu) => {
          const menuElement = document.querySelector(`.${menu.path}`)
          const subMenu = menuElement?.querySelector('.sub-menu')

          if (menuElement && subMenu) {
            menuElement.addEventListener('mouseover', () => {
              subMenu.style.display = 'block'
            })
            menuElement.addEventListener('mouseout', () => {
              subMenu.style.display = 'none'
            })
          }
        })
      })
    },
    handleSelect(key) {
      // 如果有子菜单，不直接跳转
      if (key.children && key.children.length > 0) {
        return
      }
      // 没有子菜单的菜单项才跳转
      return this.$router.push({ name: key.path })
    },
    handleProductClick(pathName, event) {
      // 通过事件对象找到对应的子菜单并关闭
      const subMenu =
        event?.target?.closest('.sub-menu') ||
        event?.target?.closest('.el-menu-item')?.querySelector('.sub-menu')
      if (subMenu) {
        subMenu.style.display = 'none'
      }

      if (pathName) {
        this.$router.push({
          name: pathName
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.new-icon {
  width: 32px;
  position: absolute;
  top: 18px;
  right: -8px;
  z-index: 1;
}
.sub-menu {
  position: fixed;
  left: 0px;
  right: 0px;
  cursor: default;
  display: none;
  padding-left: 80px !important;
  padding: 20px;
  background: #fff;
  z-index: 9;
  font-size: 18px;
  line-height: 20px;
  box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.1);
  .lh32 {
    line-height: 32px;
  }
  span {
    font-size: 16px;
    margin-right: 60px;
    color: rgba(51, 51, 51, 1);
    .wb-icon {
      margin-right: 6px;
      width: 20px;
      height: 20px;
    }
  }
}
.el-menu-horizontal-warp {
  height: 100%;
  .hj-gf-menu {
    height: 100%;
    li {
      height: 100%;
      display: flex;
      align-items: center;
    }
    .el-menu-item {
      margin-bottom: 10px;
      font-size: 16px;
    }
  }
}
</style>
<style lang="scss" scoped>
/* 页面宽度小于768px
------------------------------- */
@media screen and (max-width: 768px) {
  .el-menu-horizontal-warp {
    display: none;
  }
}
/* 页面宽度大于768px小于1024px
------------------------------- */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .el-menu-item {
    padding: 0 7px !important;
  }

  .new-icon {
    top: 8px;
    right: -20px;
  }
}

.product-menu-list {
  display: flex;
  flex-wrap: wrap;
  color: #333;
  width: 60%;
  margin: 0 auto;
  min-width: 600px;

  .product-menu-item {
    display: flex;
    align-items: center;
    width: 20%;
    text-align: center;
    padding: 10px 0;
    font-size: 16px;
    &:hover {
      color: #409eff;
      cursor: pointer;
    }

    svg {
      margin-right: 4px;
    }
  }
}

.solution-menu-list {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin: 0 auto;
  max-width: 1120px;

  .solution-category-column {
    display: flex;
    flex-direction: column;
    gap: 40px;
    padding-right: 40px;
  }

  .solution-category {
    // flex: 1;
    &:nth-child(1) {
      flex: 1;
      .category-items {
        flex-direction: column;
      }
    }
    &:nth-child(2) {
      flex: 2;
    }

    .category-title {
      position: relative;
      font-size: 16px;
      font-weight: 600;
      line-height: 18px;
      color: #333;
      padding-bottom: 8px;
      padding-left: 10px;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        width: 4px;
        height: 18px;
        background-color: #409eff;
        border-radius: 4px;
      }
    }

    .category-items {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
      padding-left: 10px;
      max-width: 560px;

      .category-item {
        font-size: 16px;
        padding: 6px 0;
        cursor: pointer;
        min-width: 100px;
        color: #333;
        flex: 1;
        min-width: 144px;

        &:hover {
          color: #409eff;
        }

        .category-item-text {
          position: relative;
          .new-icon {
            position: absolute;
            right: -32px;
            top: -8px;
            width: 32px;
          }
        }
      }
    }
  }
}
</style>
